"use client"

import { createContext, useContext, useState, useEffect, FC, ReactNode } from 'react'
import { SiteContent } from '@/src/lib/content/types'
import { defaultContent } from '@/src/lib/content/defaults'
import { defaultContentFr } from '@/src/lib/content/defaults_fr'
import { useLanguage } from '@/src/context/LanguageContext'

const ContentContext = createContext<SiteContent>(defaultContent)

export const useContent = () => useContext(ContentContext)

export const ContentProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { lang } = useLanguage()
  const [content, setContent] = useState<SiteContent>(
    lang === 'fr' ? defaultContentFr : defaultContent
  )

  useEffect(() => {
    setContent(lang === 'fr' ? defaultContentFr : defaultContent)
  }, [lang])

  useEffect(() => {
    if (lang === 'fr') return
    fetch('/api/content')
      .then((r) => r.json())
      .then((data: Partial<SiteContent>) => {
        if (data && typeof data === 'object') {
          setContent((prev) => ({ ...prev, ...data }))
        }
      })
      .catch(() => {})
  }, [lang])

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
}
